import { render, staticRenderFns } from "./dedMsgList.vue?vue&type=template&id=d974e3f2"
import script from "./dedMsgList.vue?vue&type=script&lang=js"
export * from "./dedMsgList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports